
import React from "react";
import { useState, useEffect,useRef } from "react";
import { BiEdit, BiSave } from "react-icons/bi";
import { Button, Input } from "reactstrap";

export default function EditActionRow({ action, handleSave, index, openTextArea }) {
  const [inputValue, setInputValue] = useState(action);
  const [editMode, setEditMode] = useState(false);
  const inputRef = useRef(null);
  
   useEffect(() => {
    setInputValue(action);
  }, [action]);

   if(openTextArea){ useEffect(() => {
    if (inputRef.current) {
      inputRef.current.style.height = "auto"; // reset first
      inputRef.current.style.height = inputRef.current.scrollHeight + "px";
    }
  }, [inputValue]);}

  return (
    <div className="d-flex align-items-center">
      <Input
      innerRef={inputRef}
        type="textarea"
        className="border-none"
        style={{ width: "98%",resize:openTextArea? "none":''}}
        onChange={(e) => {
         setInputValue(e.target.value);
          handleSave(e.target.value, index);
        }}
        value={inputValue}
       // rows={3}
       {...(!openTextArea ? { rows: 3 } : {})} 
        
      />
    </div>
  );
}
